
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    components: {
    }
})
export default class InfoModal extends Vue {

    @Prop() img: string;
    @Prop() text: string;
    @Prop() subtitle: string;
    @Prop() confirm: string;
    @Prop() deny: string;

    @Prop() confirmCb: any;
    @Prop() denyCb: any;

    created() {
    }

}
